<button mat-icon-button (click)="open($event)" i18n-title title="Help manual">
  <mat-icon>help</mat-icon>
</button>
